type FileNameLabelProps = { fileName: string };

export function FileNameLabel({ fileName }: FileNameLabelProps) {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex === -1) return <>{fileName}</>;
  return (
    <>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
        {fileName.slice(0, dotIndex)}
      </span>
      <span style={{ flexShrink: 0 }}>{fileName.slice(dotIndex)}</span>
    </>
  );
}
